import { productButtonOnClick } from '../helpers/product_helper';
import { initDefaultSwiper } from '../src/swiper';

productButtonOnClick();
initDefaultSwiper();
